import { render, staticRenderFns } from "./DemoRatingItemSlot.vue?vue&type=template&id=6d6b1e1e&"
import script from "./DemoRatingItemSlot.vue?vue&type=script&lang=js&"
export * from "./DemoRatingItemSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VIcon,VRating})
